import React from 'react';
import { Skeleton } from '@ok/okd';
import { calc, subscribe } from '@ok/blade';
import {
  EVENT_EMITTER_KEYS,
  PLACEHOLDER,
} from '@pages/currencyInfo/common/context';
import CurrencyInfoContext from '@pages/currencyInfo/context';
import { ChartType } from './ChartEnum';

import './index.less';
import ChartWrapper from '../ChartWrapper';

class Chart extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      chartType: ChartType.ONE_DAY,
      price: null,
      quotePrecision: null,
    };

    this.priceListen = subscribe.listen(
      EVENT_EMITTER_KEYS.currencyPrice,
      this.setPrice
    );
  }

  setPrice = ({ price, quotePrecision }) => {
    price && this.setState({ price, quotePrecision });
  };

  renderTypeSelector = () => {
    const { chartType } = this.state;
    const selectorList = [];

    Object.keys(ChartType).forEach((key) => {
      const type = ChartType[key];
      const labelClass = `label ${
        chartType.id == type.id ? 'selected' : 'unselected'
      }`;
      const selector = (
        <div
          className={labelClass}
          key={key}
          onClick={() => {
            this.handleChartTypeChange(type);
          }}
        >
          {type.label}
        </div>
      );
      selectorList.push(selector);
    });
    return selectorList;
  };

  handleChartTypeChange = (type) => {
    this.setState({ chartType: type });
  };

  componentWillUnmount() {
    this.priceListen.remove();
  }

  checkPlus = (
    supportSale,
    exchangePriceChangePercentage,
    salePriceChangePercentage
  ) => {
    if (supportSale) {
      return salePriceChangePercentage?.slice(0, 1) === '+';
    }
    return exchangePriceChangePercentage?.slice(0, 1) === '+';
  };

  getPriceChangePer = (
    supportSale,
    exchangePriceChangePercentage,
    salePriceChangePercentage
  ) => {
    if (supportSale) {
      if (salePriceChangePercentage?.trim().length === 0) {
        return PLACEHOLDER;
      }
      return salePriceChangePercentage;
    }
    if (exchangePriceChangePercentage?.trim().length === 0) {
      return PLACEHOLDER;
    }
    return exchangePriceChangePercentage;
  };

  render() {
    const { chartType, price, quotePrecision } = this.state;

    return (
      <div className="chart-box">
        <CurrencyInfoContext.Consumer>
          {(props) => {
            const { currency, currencyInfo, loading } = props;
            const { id: currencyId } = currency;
            const {
              supportSale,
              exchangeLatestPrice,
              quotePrecision: exchangeQuotePrecision = 0,
              exchangePriceChangePercentage,
              salePriceChangePercentage,
            } = currencyInfo;

            const isMinus = !this.checkPlus(
              supportSale,
              exchangePriceChangePercentage,
              salePriceChangePercentage
            );
            const changePer = this.getPriceChangePer(
              supportSale,
              exchangePriceChangePercentage,
              salePriceChangePercentage
            );
            const isEmptyValue = changePer === PLACEHOLDER;

            const p = price || exchangeLatestPrice;
            const q = quotePrecision || exchangeQuotePrecision;
            const priceDisplay = p
              ? calc.showFloorTruncation(p, q)
              : PLACEHOLDER;

            const changeClass = `change ${isMinus ? 'red' : 'green'}`;
            return (
              <>
                <div className="chart-header">
                  <div className="chart-header-left">
                    <div className="price">{`¥${priceDisplay}`}</div>
                    {!isEmptyValue && (
                      <div className={changeClass}>
                        <span>{changePer}</span>
                      </div>
                    )}
                    <div className="change">{isEmptyValue && changePer}</div>
                  </div>
                  {supportSale && (
                    <div className="type-selector">
                      {this.renderTypeSelector()}
                    </div>
                  )}
                </div>

                {supportSale && (
                  <div className="chart-body">
                    <ChartWrapper
                      currencyId={currencyId}
                      type={chartType}
                      isMinus={isMinus}
                    />
                  </div>
                )}
                {loading && <Skeleton.Input className="chart-body" active />}
              </>
            );
          }}
        </CurrencyInfoContext.Consumer>
      </div>
    );
  }
}

export default Chart;
